module.exports = __webpack_public_path__ + "media/images/choose/purchase_course_student-3f6cd0bb0f73c920ff1df45f89f1f631.png";